import { https } from "../http";
import store from "../store";
import {
  setNotificationLoading,
  setNotifications,
  setNotificationsCount,
  setReadAllNotifications,
  setReadNotification,
} from "../store/reducers/notification";
import { showError } from "../utils/index";

const getNotifications = async (payload) => {
  try {
    store.dispatch(setNotificationLoading(true));
    let response = await https().get(
      `/notification/get-all?page=${payload?.page}&perPage=${payload?.limit}&userId=${payload?.userId}${payload?.filter ? `&filter=${payload?.filter}` : ''}`
    );
    if (response) {
      store.dispatch(setNotifications(response.data));
    }
  } catch (error) {
    let _error = error?.response?.data?.message;
    showError(_error, error?.response?.status);
    store.dispatch(setNotificationLoading(false));
    return false;
  }
};

const getNotificationsCount = async (payload) => {
  try {
    // store.dispatch(setNotificationLoading(true));
    let response = await https().get(`/notification/get-count`);
    if (response) {
      store.dispatch(setNotificationsCount(response.data));

      // store.dispatch(setNotifications(response.data));
    }
  } catch (error) {
    // let _error = error?.response?.data?.message;
    // showError(_error, error?.response?.status);
    // store.dispatch(setNotificationLoading(false));
    return false;
  }
};

const readNotification = async (payload) => {
  try {
    let response = await https().post("/notification/read-notification", {
      notificationId: payload,
    });
    if (response) {
      store.dispatch(setReadNotification(response.data));
      return response?.data;
    }
  } catch (error) {
    let _error = error?.response?.data?.message;
    showError(_error, error?.response?.status);
  }
};

const readAllNotifications = async () => {
  try {
    let response = await https().post("/notification/read-all");
    if (response) {
      store.dispatch(setReadAllNotifications(true));
      return response?.data;
    }
  } catch (error) {
    console.log(error);
  }
};

export {
  getNotifications,
  getNotificationsCount,
  readNotification,
  readAllNotifications,
};
